<template>
    <div class="header navbar">
        <div class="col-md-5 fixed-top m-auto mrg-top-70 line-height" :show='alert.dismissCountDown'>
                <b-alert
                    :show="alert.dismissCountDown"
                    dismissible
                    variant="info"
                    @dismissed="alert.dismissCountDown=0 , structure_name=''"
                    @dismiss-count-down="countDownChanged">
                    <div class="text-center m-auto text-info">
                    <span  class="lead "> Vous êtes connecté à la structure :<br> {{structure_name}}<b></b> </span> 
                        <br> <hr> cette alerte disparaîtra après {{alert.dismissCountDown}} secondes </div>
                </b-alert>
            </div>
        <div class="header-container" v-show="false">
            <ul class="nav-left">
                <li>
                    <a class="side-nav-toggle" @click.prevent="navToogle">
                        <!--< <i :class="{'ti-arrow-left': !isCollapsed, 'ti-arrow-right': isCollapsed}"></i> 
                        -->
                        <i class="ti-menu"> </i>
                    </a>
                </li>
            </ul>
            <ul class="nav-right mr-4">
                <header-notifications class=""></header-notifications>
                <header-user-profile class="width" @Choisir-Structure-done= "showAlert"></header-user-profile>
            </ul>
            
        </div>
          <b-navbar toggleable="lg"  variant="white" v-show="true">

            <b-navbar-brand class="nav-left">
                <i class="ti-menu pointer" @click.prevent="navToogle"></i>
            </b-navbar-brand>


            <b-navbar-toggle target="user-collapse" class="nav-right">
                <template #default="{ expanded  }">
                    <i :class="expanded ? 'ti-angle-up' :'ti-angle-down '" ></i>
                </template>
            </b-navbar-toggle>

    <b-collapse id="user-collapse" is-nav>
      
      <!-- Right aligned nav items -->
      <b-navbar-nav class="ml-auto"> 
        <header-notifications > </header-notifications>
        <b-nav-item class="m-auto" >
            <header-user-profile  @Choisir-Structure-done= "showAlert"></header-user-profile>
        </b-nav-item>
       
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
    </div>
    

</template>

<script>
    import {TOOGLE_SIDENAV} from "../../store/actions/app";
    import HeaderSearch from "./HeaderSearch";
    import HeaderNotifications from "./HeaderNotifications";
    import HeaderUserProfile from "./HeaderUserProfile";

    export default {
        name: "Header",
        components: {HeaderUserProfile, HeaderNotifications, HeaderSearch},
        data (){
            return{
                alert : {
                    dismissSecs: 10,
                    dismissCountDown: 0,
                },
                structure_name : "",
                error : false,
                window: {
                    width: 0,
                    height: 0
                },
                device: false,
                minWidth : 400,
                userToogle : false,
            }
        },
        created() {
            window.addEventListener('resize', this.handleResize);
            this.handleResize();
        },
        destroyed() {
            window.removeEventListener('resize', this.handleResize);
        },
        computed: {
            isCollapsed(){
                return this.$store.getters.isCollapsed;
            }
        },
        methods : {
            navToogle: function () {
                this.$store.commit(TOOGLE_SIDENAV);
            },
            countDownChanged(dismissCountDown) {
                this.alert.dismissCountDown = dismissCountDown;
            },
            showAlert(structure_name) {
                this.structure_name=structure_name;
                this.alert.dismissCountDown = this.alert.dismissSecs;
            },
            handleResize() {
                this.window.width = window.innerWidth;
                this.window.height = window.innerHeight;
                this.device=(this.window.width<=this.minWidth)? true : false ;
            },
        }
    }
</script>
<style scoped>
.width {
    width : 240px
}
</style>